<template>
	<v-expansion-panels v-model="panel" accordion flat hover multiple class="px-1">
		<v-expansion-panel
			v-for="item in panel_items"
			:key="item.value"
		>
			<v-expansion-panel-header color="#FAFAFA" class="px-3 py-0" style="min-height: 32px;">
				<div style="font-size: 16px">{{ item.text }}</div>
			</v-expansion-panel-header>
			<v-expansion-panel-content color="#FAFAFA">
				<v-autocomplete
					v-model="assign"
					:items="assign_items"
					:loading="assign_loading"
					:search-input.sync="assignSearch"
					:color="color"
					background-color="#FFFFFF"
					item-text="name"
					item-value="id"
					placeholder="Search for people"
					dense
					outlined
					return-object
					hide-details
					clearable
					@change="onAssignChange($event)"
				>
					<template v-slot:append>
						<v-icon></v-icon>
					</template>
				</v-autocomplete>
				<v-treeview
					:items="assignItemsLocal"
					dense
					open-on-click
					return-object
					expand-icon="mdi-chevron-down"
				>
					<template v-slot:prepend="{item }">
						<v-checkbox
							class="mt-0 pt-0"
							style="font-size: 14px"
							v-if="!item.children"
							v-model="assigned_to"
							:color="colorCalendars[`${item.id}`]"
							:value="item"
							:label="item.name"
							dense
							hide-details
							@click="$emit('selected', {id: item.id, assigned: assigned_to})"
						></v-checkbox>
					</template>
					<template v-slot:label="{item }">
						<span v-if="item.children" style="font-size: 16px">{{ item.name }}</span>
						<span v-if="!item.children" style="font-size: 16px"></span>
					</template>
				</v-treeview>
			</v-expansion-panel-content>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
const Panel_Items = [
	{
		text: 'Calendars',
		value: 'calendars'
	}
];
const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;

export default {
	name: 'CalendarPanel',
	props: {
		assignItems: {
			type: Array,
			default: () => []
		},
		assignedTo: {
			type: Array,
			default: () => []
		},
		colorCalendars: {
			type: Object,
			default: () => {}
		},
		color: {
			type: String,
			default: ''
		},
		calendar: {
			type: Boolean,
			default: true
		}
	},
	data() {
		this.panel_items = Panel_Items;
		return {
			panel: this.calendar ? [0]: [],
			assigned_to: this.assignedTo,
			assign: { id: '', name: '', type: 0},
			assign_items: [],
			assign_loading: false,
			assignSearch: null,
			total_assign_items: []
		}
	},
	watch: {
		assign() {
			if (this.assign === null) {
				this.assign = { id: '', name: '', type: 0};
				this.assign_items = [];
			}
		},
		assignSearch(val) {
			val && val !== this.assign.name && this.assignQuery(val);
		},
		panel() {
			const is_open = this.panel.length !== 0;
			if (is_open !== this.calendar) {
				this.$emit('calendar', is_open);
			}
		},
		assignItems: {
			handler(val) {
				if (val.length !== 0) {
					this.total_assign_items = this.getAssignItems();
				}
			},
			deep: true			
		}
	},
	computed: {
		assignItemsLocal() {
			let assign_items_local = [];
			assign_items_local = this.sortAssignedTree(this.assigned_to, this.assignItems);
			return assign_items_local;
		}
	},
	methods: {
		getAssignItems() {
			// const assign_items = [...this.assignItems[0].children, ...this.assignItems[1].children, ...this.assignItems[2].children];

			const assign_items = [...this.assignItems[0].children];
			return assign_items;
		},
		assignQuery(key) {
			this.assign_loading = true;
			const total_assign_items = this.getAssignItems();

			const filter = total_assign_items.filter(a => {
				const name_str = a.name.toUpperCase();
				const key_str = key.toUpperCase();

				return name_str.includes(key_str);
			});

			this.assign_items = filter;
			this.assign_loading = false;
		},
		onAssignChange(assign_obj) {
			if (assign_obj) {
				const existed_tmp = this.assigned_to.filter(a => { return a.id === assign_obj.id });
				if (existed_tmp.length === 0) {
					this.assigned_to.push(assign_obj);
					this.$emit('selected', {id: assign_obj.id, assigned: this.assigned_to});
				}
			}
		},
		sortAssignedTree(selected, tree) {
			const selected_employee = selected.filter(s => { return s.type === ALLEMPLOYEES });
			if (selected_employee.length !== 0) {
				const selected_employee_ids = selected_employee.map(s => { return s.id });

				const pre_sort_list_tmp = tree.filter(t => {return t.id === ALLEMPLOYEES});
				const pre_sort_list = pre_sort_list_tmp[0].children;

				const other_list = pre_sort_list.filter(p => {return !selected_employee_ids.includes(p.id)});

				const employee_arr = [...selected_employee, ...other_list];
				tree.forEach(t => {
					if (t.id === ALLEMPLOYEES) {
						t.children = employee_arr;
					}
				});
			}

			const selected_role = selected.filter(s => { return s.type === ROLES });
			if (selected_role.length !== 0) {
				const selected_role_ids = selected_role.map(s => { return s.id });

				const pre_sort_list_tmp = tree.filter(t => {return t.id === ROLES});
				const pre_sort_list = pre_sort_list_tmp[0].children;

				const other_list = pre_sort_list.filter(p => {return !selected_role_ids.includes(p.id)});

				const role_arr = [...selected_role, ...other_list];
				tree.forEach(t => {
					if (t.id === ROLES) {
						t.children = role_arr;
					}
				});
			}

			const selected_department = selected.filter(s => { return s.type === DEPARTMENTS });
			if (selected_department.length !== 0) {
				const selected_department_ids = selected_department.map(s => { return s.id });

				const pre_sort_list_tmp = tree.filter(t => {return t.id === DEPARTMENTS});
				const pre_sort_list = pre_sort_list_tmp[0].children;

				const other_list = pre_sort_list.filter(p => {return !selected_department_ids.includes(p.id)});

				const department_arr = [...selected_department, ...other_list];
				tree.forEach(t => {
					if (t.id === DEPARTMENTS) {
						t.children = department_arr;
					}
				});
			}

			return tree;
		}
	}
}
</script>
<style lang="scss" scoped>
::v-deep {
	.v-expansion-panel-content__wrap {
		padding: 0 12px;
	}
	// .v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input::placeholder {
	// 	font-family: 'Roboto';
	// 	font-style: normal;
	// 	font-weight: 500;
	// 	color: #81CC00;
	// }
}
</style>
